import { render, staticRenderFns } from "./DicomTab.vue?vue&type=template&id=d341b81c&"
import script from "./DicomTab.vue?vue&type=script&lang=ts&"
export * from "./DicomTab.vue?vue&type=script&lang=ts&"
import style0 from "./DicomTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports